function n(){return(navigator.vendor.match(/apple/i)||"").length>0}function t(){return(navigator.platform.match(/Win/i)||"").length>0}export{n as isSafari,t as isWindows};
